import React from 'react';
import { Button } from './ui/button';
import { telegramAlerts } from '../data/mockData';

const AlertsSection = () => {
  return (
    <section className="relative py-20 bg-[#06070d]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Never Miss an <span className="text-[#f2e2a6]">Opportunity.</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Get real-time arbitrage alerts delivered straight to your Telegram. Each alert includes the spread, expected value, and direct trading links.
          </p>
        </div>

        {/* Telegram alerts */}
        <div className="bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden max-w-2xl mx-auto">
          {/* Telegram header */}
          <div className="bg-[#0088cc] px-6 py-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <span className="text-[#0088cc] font-bold">🌘</span>
              </div>
              <div>
                <div className="text-white font-semibold">moon.land Signals</div>
                <div className="text-white/80 text-xs">bot • 2.4K subscribers</div>
              </div>
            </div>
          </div>

          {/* Telegram messages */}
          <div className="bg-white p-6 space-y-4">
            {telegramAlerts.map((alert) => (
              <div key={alert.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div className="text-[#0088cc] font-semibold text-sm mb-2">moon.land Bot</div>
                <div className="text-gray-900 font-medium mb-3">📊 {alert.title}</div>
                <div className="flex items-center space-x-3 mb-3">
                  <span className="text-[#f2e2a6] font-bold text-sm">💰 {alert.spread} Spread</span>
                  <span className="text-gray-900 font-semibold text-sm">•{alert.ev} EV</span>
                </div>
                <div className="text-gray-600 text-sm mb-3">Combined: {alert.combinedCost}</div>

                <div className="space-y-2">
                  <div className="flex items-center justify-between bg-white rounded-lg p-3 border border-gray-300">
                    <div className="flex items-center space-x-2">
                      <div className="w-6 h-6 bg-[#f2e2a6] rounded-full" />
                      <div>
                        <div className="text-gray-900 font-semibold text-xs">{alert.platform1.name}</div>
                        <div className="text-gray-600 text-xs">{alert.platform1.type} @ {alert.platform1.price}</div>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between bg-white rounded-lg p-3 border border-gray-300">
                    <div className="flex items-center space-x-2">
                      <div className="w-6 h-6 bg-[#f59e0b] rounded-full" />
                      <div>
                        <div className="text-gray-900 font-semibold text-xs">{alert.platform2.name}</div>
                        <div className="text-gray-600 text-xs">{alert.platform2.type} @ {alert.platform2.price}</div>
                      </div>
                    </div>
                  </div>

                  <div className="flex space-x-2 pt-2">
                    <Button size="sm" className="flex-1 bg-[#0088cc] text-white hover:bg-[#0088cc]/90 text-xs">
                      Trade {alert.platform1.name} →
                    </Button>
                    <Button size="sm" className="flex-1 bg-[#0088cc] text-white hover:bg-[#0088cc]/90 text-xs">
                      Trade {alert.platform2.name} →
                    </Button>
                  </div>
                </div>

                <div className="text-gray-500 text-xs mt-3">{alert.time}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA button */}
        <div className="flex justify-center mt-12">
          <a href="https://t.me/ArbXSignalsBot" target="_blank" rel="noopener noreferrer"><Button className="bg-[#0088cc] text-white hover:bg-[#0088cc]/90 px-8 py-6 transition-all hover:scale-105">
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12a12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472c-.18 1.898-.962 6.502-1.36 8.627c-.168.9-.499 1.201-.82 1.23c-.696.065-1.225-.46-1.9-.902c-1.056-.693-1.653-1.124-2.678-1.8c-1.185-.78-.417-1.21.258-1.91c.177-.184 3.247-2.977 3.307-3.23c.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345c-.48.33-.913.49-1.302.48c-.428-.008-1.252-.241-1.865-.44c-.752-.245-1.349-.374-1.297-.789c.027-.216.325-.437.893-.663c3.498-1.524 5.83-2.529 6.998-3.014c3.332-1.386 4.025-1.627 4.476-1.635z"/>
            </svg>
            Start The Bot
          </Button></a>
        </div>
      </div>
    </section>
  );
};

export default AlertsSection;
